import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ErrorRoute } from '@app/modules/errors/error-routes';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
  },
  {
    path: 'login',
    loadChildren: () => import('./modules/login/login.module').then(m => m.LoginModule),
  },
  {
    path: 'staff-login',
    loadChildren: () => import('./modules/staff-login/staff-login.module').then(m => m.StaffLoginModule),
  },
  {
    path: 'assign-blast',
    loadChildren: () => import('./modules/assign-blast-mobile/assign-blast-mobile.module').then(m => m.AssignBlastMobileModule),
  },
  {
    path: 'booking/:bookingId',
    loadChildren: () => import('./modules/booking/booking.module').then(m => m.BookingModule),
    pathMatch: 'full'
  },
  {
    path: 'error',
    loadChildren: () => import('./modules/errors/errors.module').then(m => m.ErrorsModule),
  },
  {
    path: '**',
    redirectTo: ErrorRoute.e404
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: false })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
